import React from 'react'
import PropTypes from 'prop-types'

const UserPlusCircleIcon = (props) => {
  const { color = '#000000', bgColor = '#FFFFFF', classes = 'w-20' } = props
  return (
    <svg
      width="110"
      height="110"
      viewBox="0 0 110 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <g clipPath="url(#clip0_9846_28595)">
        <circle cx="55.0317" cy="55.166" r="54.5337" fill={bgColor} />
        <path
          d="M70.3303 71.915C69.4235 63.8142 62.5744 57.6894 54.423 57.6894H44.6876C36.5362 57.6894 29.6871 63.8142 28.7804 71.915L28.3848 75.4335C44.0084 80.043 58.1221 80.043 70.7222 75.4335L70.3303 71.915ZM49.5553 53.9433C55.7686 53.9433 60.8061 48.9058 60.8061 42.6925C60.8061 36.4792 55.7686 31.4417 49.5553 31.4417C43.3419 31.4417 38.3044 36.4792 38.3044 42.6925C38.3062 48.9058 43.3438 53.9433 49.5553 53.9433Z"
          fill={color}
        />
        <path
          d="M82.0377 50.6743C82.0377 49.7152 81.2592 48.9368 80.3001 48.9368H75.1705V43.8072C75.1705 42.8481 74.392 42.0696 73.4329 42.0696C72.4738 42.0696 71.6953 42.8481 71.6953 43.8072V48.9368H66.5657C65.6048 48.9368 64.8281 49.7152 64.8281 50.6743C64.8281 51.6352 65.6048 52.4119 66.5657 52.4119H71.6953V57.5415C71.6953 58.5006 72.4738 59.2791 73.4329 59.2791C74.392 59.2791 75.1705 58.5006 75.1705 57.5415V52.4119H80.3001C81.2592 52.4137 82.0377 51.6352 82.0377 50.6743Z"
          fill={color}
        />
      </g>
      <defs></defs>
    </svg>
  )
}

UserPlusCircleIcon.propTypes = {
  color: PropTypes.string,
  bgColor: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(UserPlusCircleIcon)
